@if (isLoading | async) {
  <div class="loader-overlay">
    <mat-progress-spinner class="spinner" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
